import { MfsError, MfsStatusCode } from '@metaos/mfs-telemetry';

/** Custom error for Label ID being in use */
export class MfsLabelIdInUseError extends MfsError {
  constructor(public itemId: string) {
    super(`label and labelId are already in use by itemId: ${itemId}.`, MfsStatusCode.NotAllowed);
  }
}
